import React, { useContext, useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { useTranslation } from "react-i18next";
import { AuthContext } from "../../../Contexts/AuthContext";
import { GlobalContext } from "../../../Contexts/GlobalContextProvider";
import { reportService } from "../../../Services/report.service";
import SpinnerLoading from "../../Common/SpinnerLoading";

const Table = () => {
  const { t: translator } = useTranslation();
  const { updateLocName } = useContext(GlobalContext);
  const { tenantId } = useContext(AuthContext);
  const [reports, setReports] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [update, setUpdate] = useState(new Date());

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
    totalSize: 0,
  });
  useEffect(() => {
    updateLocName("invoices-invoicesUnfiscalizedAccounts");
  }, []);
  useEffect(() => {
    setIsLoading(true);
    reportService
      .invoicesUnfiscalDetails(
        tenantId,
        pagination.pageIndex,
        pagination.pageSize
      )
      .then((res) => {
        setReports(res.data.data);
        setIsLoading(false);
      })
      .catch((err) => console.log(err));
  }, [update]);

  function currencyFormatter(cell) {
    return new Intl.NumberFormat("hr", {
      style: "currency",
      currency: "EUR",
    }).format(Number(cell));
  }

  function dateTimeFormatter(cell, row) {
    return new Intl.DateTimeFormat("hr", {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: false,
      timeZone: "Europe/Zagreb",
    }).format(new Date(cell));
  }

  const columns = [
    {
      dataField: "",
      text: translator("UnfiscalizedAccount-DocumentNumber"),
      formatter: function (cell, row) {
        console.log(row);
        return `${row.documentNumber}/${row.storeTag}/${row.posTag}`;
      },
    },
    {
      dataField: "issued",
      text: translator("UnfiscalizedAccounts-Issued"),
      formatter: dateTimeFormatter,
    },
    {
      dataField: "zki",
      text: translator("ZKI"),
    },
    {
      dataField: "payValue",
      text: translator("UnfiscalizedAccounts-PayValue"),
      formatter: currencyFormatter,
    },

    {
      dataField: "errorDescription",
      text: translator("UnfiscalizedAccounts-ErrorDescription"),
    },
  ];

  const handleTableChange = (type, { page, sizePerPage }) => {
    setPagination({
      ...pagination,
      pageIndex: sizePerPage != pagination.pageSize ? 0 : page - 1,
      pageSize: sizePerPage,
    });

    setUpdate(new Date());
  };
  const handleFiscalization = () => {
    reportService
      .fiscalizeInvoices()
      .then((res) => console.log(res))
      .catch((err) => console.log(err));
  };

  const RemoteAll = ({ data, page, totalSize, onTableChange }) => (
    <div>
      <BootstrapTable
        showHeader={false}
        remote
        keyField="reportId"
        data={data}
        columns={columns}
        noDataIndication={translator("No-Data")}
        pagination={paginationFactory({
          page,
          hideSizePerPage: true,
          totalSize,
        })}
        onTableChange={onTableChange}
      />
    </div>
  );

  return (
    <div className="p-2 pt-3">
      <div className="card container-fluid p-0">
        <div className="card-header card-wrap">
          <span>{translator("Main-Sidebar-InvoicesUnfiscalizedAccounts")}</span>
        </div>
        <div className="card-body">
          {/*<div className="form-group float-right">
            <button
              onClick={handleFiscalization}
              className="btn btn-primary"
              type="submit"
            >
              {translator("UnfiscalizedAccounts-Fiscalize")}
            </button>
          </div>*/}

          {isLoading && (
            <div className="dashboard-card-spinner">
              <SpinnerLoading />
            </div>
          )}
          {!isLoading && (
            <RemoteAll
              data={reports}
              page={pagination.pageIndex + 1}
              totalSize={pagination.totalSize}
              onTableChange={handleTableChange}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Table;
